import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import { getConsent, setConsent, loadTrackingScripts } from "../utils/tracking";

const CookieNotice: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Don't show on /privacy-choices — redundant with the full controls there
    if (window.location.pathname.startsWith("/privacy-choices")) return;

    // Only show when no choice has been made yet
    if (getConsent() === null) {
      const timer = setTimeout(() => setVisible(true), 500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    setConsent("accepted");
    loadTrackingScripts(); // load immediately — no page reload needed
    setVisible(false);
  };

  // Dismiss only — no consent granted, notice re-appears after 30 days
  const handleDismiss = () => {
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-notice" role="region" aria-label="Cookie notice">
      <p className="cookie-notice-text">
        VoltHub uses cookies and similar technologies to understand how the Site
        is used and improve your experience. See our{" "}
        <Link to="/privacy" className="cookie-notice-link" target="_blank">
          Privacy Policy
        </Link>{" "}
        or manage{" "}
        <Link
          to="/privacy-choices"
          className="cookie-notice-link"
          target="_blank"
        >
          Your Privacy Choices
        </Link>
        .
      </p>
      <div className="cookie-notice-actions">
        <button
          onClick={handleAccept}
          className="cookie-notice-btn cookie-notice-btn--accept"
        >
          Accept
        </button>
        <button
          onClick={handleDismiss}
          className="cookie-notice-btn cookie-notice-btn--decline"
        >
          Decline
        </button>
        <button
          onClick={handleDismiss}
          className="cookie-notice-close"
          aria-label="Dismiss"
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default CookieNotice;
